import {
	queryCapacityAction,
	rejectQueryCapacityAction,
	resolveQueryCapacityAction,
	returnCapacityAction,
	useCapacityAction,
} from '../actions/capacity.actions';
import {
	createReducer,
	ActionCreatorWithPayload,
	Draft,
} from '@reduxjs/toolkit';
import { QueryCapacityResponseBody } from '../services/capacity';
import { STATUS_ENUM } from '../types/reducers.types';
import { CapacityItem } from '../utils/capacity';

export type CapacityStoreState = Record<
	string,
	{
		data: QueryCapacityResponseBody | null;
		error: unknown | null;
		metadata: {
			initialized: boolean;
			ready: boolean;
			stale: boolean;
			status: `${STATUS_ENUM}`;
		};
	}
>;

export const initialCapacityStoreState: CapacityStoreState = {};

export default createReducer(initialCapacityStoreState, builder => {
	// - Loading state

	builder.addCase(queryCapacityAction, (state, action) => {
		setLoadingState(state, action);
	});

	builder.addCase(useCapacityAction, (state, action) => {
		setLoadingState(state, action);
	});

	builder.addCase(returnCapacityAction, (state, action) => {
		setLoadingState(state, action);
	});

	// - Reject state

	builder.addCase(rejectQueryCapacityAction, (state, action) => {
		const { item: i, error } = action.payload;
		const item = i.toLowerCase();

		if (typeof state[item] === 'undefined') {
			state[item] = {
				metadata: {},
			} as CapacityStoreState[keyof CapacityStoreState];
		}

		if (
			typeof state[item].data === 'undefined' ||
			state[item].data === null
		) {
			state[item].metadata.stale = false;
			state[item].data = null;
		} else {
			state[item].metadata.stale = true;
		}

		state[item].error = error;
		state[item].metadata.initialized = true;
		state[item].metadata.ready = true;
		state[item].metadata.status = 'error';
	});

	// - Resolve state

	builder.addCase(resolveQueryCapacityAction, (state, action) => {
		const { item: i, data } = action.payload;
		const item = i.toLowerCase();

		if (typeof state[item] === 'undefined') {
			state[item] = {
				metadata: {},
			} as CapacityStoreState[keyof CapacityStoreState];
		}

		state[item].data = data;
		state[item].error = null;
		state[item].metadata.initialized = true;
		state[item].metadata.ready = true;
		state[item].metadata.stale = false;
		state[item].metadata.status = 'success';
	});
});

function setLoadingState(
	state: Draft<CapacityStoreState>,
	action: ReturnType<ActionCreatorWithPayload<{ item: CapacityItem }>>,
): void {
	const { item: i } = action.payload;
	const item = i.toLowerCase();

	if (typeof state[item] === 'undefined') {
		state[item] = {
			metadata: {},
		} as CapacityStoreState[keyof CapacityStoreState];
	}

	if (typeof state[item].error === 'undefined') {
		state[item].error = null;
	}

	if (typeof state[item].data === 'undefined' || state[item].data === null) {
		state[item].metadata.stale = false;
		state[item].data = null;
	} else {
		state[item].metadata.stale = true;
	}

	state[item].metadata.initialized = true;
	state[item].metadata.ready = false;
	state[item].metadata.status = 'pending';
}
